import React, { useContext } from 'react'

import { AuthorizationForm } from '../auth'
import { AppContext } from '../App'

const PrivateRoute = ({ children }) => {
  const { state } = useContext(AppContext)

  if (state.isLoggedIn === null) {
    return
  }

  return state.isLoggedIn ? children : <AuthorizationForm />
}

export { PrivateRoute }
